import React from 'react'
import styled from '@emotion/styled'
import TwoButtonModal from '../generic/modals/TwoButtonModal'
import { FlexRowDiv, ModalContentNormal } from '../generic/Basics'
import { fontSize2XSmall, goldLight10 } from '../../constants/principles'
import ExclamationTriangle from '../generic/ExclamationTriangle'

export default ({ setShowModal, showModal, changeTrim, trims, trim }) => {
  return (
    <TwoButtonModal
      name={showModal}
      positiveCopyOverride={'Change Style'}
      onClickPositive={e => {
        changeTrim(showModal)
        setShowModal(false)
      }}
      onClickNegative={e => setShowModal(false)}
      title={
        <FlexRowDiv>
          <StyledTriangle>
            <ExclamationTriangle colorFill={goldLight10} width={24} height={24} />
          </StyledTriangle>
          Please Note
        </FlexRowDiv>
      }>
      <ModalContentNormal>
        <P>
          You've asked to change this vehicle's style (trim) from
          <br />
          <strong>{trim && trim.displayName}</strong> to <strong>{((trims && trims.find(t => +t.trimId === +showModal)) || {}).displayName}</strong>.
        </P>
        <P>This will change - or reset - items like color, options, vehicle modifications, vehicle history and condition throughout the questionnaire.</P>
        <P>
          <strong>Please check all information after changing the style.</strong>
        </P>
      </ModalContentNormal>
    </TwoButtonModal>
  )
}

const StyledTriangle = styled(FlexRowDiv)`
  padding-right: 8px;
`
const P = styled.p`
  font-size: ${fontSize2XSmall};
`
